<template>
  <v-container>
    <h1>{{ $t('Your transactions') }}</h1>

    <div class="mt-2 mb-4">
      <v-chip outlined color="primary" class="my-4" large>
        {{ $t('Balance') }}: <b class="ml-1">{{ formatMoney(ccBalance) }}</b>
      </v-chip>
    </div>

    <client-customer-transactions-table
      :customer-id="$store.getters.clientCustomerId"
    />
  </v-container>
</template>

<script>
import foodytekUtils from "@/mixins/foodytekUtils";
import ClientCustomerTransactionsTable from "../../components/ClientCustomerTransactionsTable.vue";
import {mapGetters} from "vuex";

export default {
  name: 'ClientCustomerMyTransactions',
  components: { 
    ClientCustomerTransactionsTable
  },
  mounted() {
    this.$store.dispatch('creditBalance/updateBalance')
  },
  computed: {
    ...mapGetters('creditBalance', ['ccBalance']),
  }
}
</script>
